module.exports = __webpack_public_path__ + "assets/img/python.42d96008.jpg";